import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';
import { getIcon } from '../iconMap';

function FacilitiesStats({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const facilities = data.facilities || [];
  const updateFacility = (i, patch) => {
    const next = facilities.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ facilities: next });
  };
  const stats = data.stats || [];
  const updateStat = (i, patch) => {
    const next = stats.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ stats: next });
  };
  return (
    <section className="py-24 bg-olive-light">
      <div className="container-page">
        <Reveal className="max-w-2xl">
          <span className="eyebrow"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
        </Reveal>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {facilities.map((f, i) => {
            const I = getIcon(f.icon);
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div className="p-6 bg-white rounded-2xl shadow-soft hover:-translate-y-1 transition h-full">
                  <I className="text-accent" size={28} />
                  <EditableText value={f.title} onChange={(t) => updateFacility(i, { title: t })} as="strong" className="block font-display text-lg mt-4 text-olive-deep" />
                  <EditableText value={f.detail} onChange={(t) => updateFacility(i, { detail: t })} as="p" multiline className="mt-2 text-sm text-ink/70 leading-relaxed" />
                </div>
              </Reveal>
            );
          })}
        </div>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {stats.map((s, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="p-8 rounded-3xl bg-olive-deep text-white text-center">
                <EditableText value={s.value} onChange={(t) => updateStat(i, { value: t })} as="div" className="font-display text-5xl text-accent font-bold" />
                <EditableText value={s.label} onChange={(t) => updateStat(i, { label: t })} as="div" className="text-sm text-white/80 mt-2" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FacilitiesStats;
